import { useEffect } from "react";

const HUBSPOT_SCRIPT_ID = "hs-script-loader";
const HUBSPOT_SCRIPT_SRC = "//js.hs-scripts.com/244667531.js";

const HubSpotChat = () => {
  useEffect(() => {
    // Prevent duplicate script injection
    if (!document.getElementById(HUBSPOT_SCRIPT_ID)) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.id = HUBSPOT_SCRIPT_ID;
      script.async = true;
      script.defer = true;
      script.src = HUBSPOT_SCRIPT_SRC;
      document.body.appendChild(script);
    }
  }, []);

  // No visible UI, just injects script
  return null;
};

export default HubSpotChat;


// NOTE: The following is the original HubSpot embed code for reference
// <!-- Start of HubSpot Embed Code --> 
// <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/244667531.js"></script> 
// <!-- End of HubSpot Embed Code -->
